module.exports = __webpack_public_path__ + "images/default_avatars/winter@2x-08ac56db61faf52b70d51970574d2748.jpg";